import { StatusCodes } from 'http-status-codes';

export const errorCodeTypes = {
  phoneVerificationCodeIncorrectError: {
    code: 'PHVE01',
    name: 'PhoneVerificationCodeIncorrectError',
    message: 'The code you entered is incorrect. Please try again',
  },
  phoneVerificationError: {
    code: 'PHVE02',
    name: 'PhoneVerificationError',
    message: 'We are unable to send the SMS. Please try again.',
  },
  phoneVerificationRateLimitError: {
    code: 'PHVE03',
    name: 'PhoneVerificationRateLimitError',
    message: 'Too many verification attempts. Please try again later.',
    status: StatusCodes.TOO_MANY_REQUESTS,
  },
  phoneVerificationBlockedError: {
    code: 'PHVE04',
    name: 'PhoneVerificationBlockedError',
    message: 'Verification is temporarily unavailable for this number.',
    status: StatusCodes.FORBIDDEN,
  },
};
